import { useMemo } from 'react'

import { createPickerPageSource } from '@/modules/upload/cloud/pickerPage/pickerPageSource'
import { requestCloudImportTicket } from '@/modules/upload/service/cloudImportTicket'

const BOX_BLOCKED_ADVICE =
  'Your Box admin may block outside apps. Download it and drop it here.'

const createBoxSource = () =>
  createPickerPageSource({
    provider: 'box',
    label: 'Box',
    blockedLinkAdvice: BOX_BLOCKED_ADVICE,
    requestTicket: requestCloudImportTicket,
  })

// Box signs in on the separate picker page, so the button shows only when that page is set up.
export const useBoxSource = () =>
  useMemo(() => {
    const source = createBoxSource()
    return source.isAvailable() ? source : null
  }, [])
